const firstLetterToUpperCase = (name: string) => name.charAt(0).toUpperCase() + name.slice(1);

export const getPreviewFromUrlOrSessionStorage = <Name>(params: {
  queryKey: string;
  isEnabled: boolean;
}): [showPreview: boolean, name: Name | null] => {
  if (!params.isEnabled) {
    return [false, null];
  }
  const nameByURL = new URLSearchParams(window.location.search).get(params.queryKey);
  nameByURL !== null && sessionStorage.setItem(`preview${firstLetterToUpperCase(params.queryKey)}Name`, nameByURL);
  const name = sessionStorage.getItem(`preview${firstLetterToUpperCase(params.queryKey)}Name`);
  return [typeof name === 'string', name as Name];
};
